import type { TicketMessage } from '@/types/ticket';
import { formatTicketMessageTime } from '@/lib/ticket-datetime';

export { formatTicketMessageTime };

export function isMessageSeenByStudent(
  message: TicketMessage,
  studentLastReadAt?: string | Date | null
): boolean {
  if (message.senderType !== 'admin' || message.isDeleted || message.isUnsent) {
    return false;
  }
  if (message.seenByStudent !== undefined) {
    return message.seenByStudent;
  }
  if (message.isRead) return true;
  if (!studentLastReadAt) return false;
  return new Date(message.createdAt).getTime() <= new Date(studentLastReadAt).getTime();
}
